import type { Router, RouteLocationNormalized } from 'vue-router'
import { useMarketStore } from '@/modules/market/store'
import { useCartStore } from '@/modules/cart/store'
import type { ConfigurationI, ConfigurationOptionI } from '@/modules/cart/types/api/CustomiseProductOptionsTypes'
import type { LocationQueryValue } from 'vue-router'

function changeOptions(optionName: string, inputName: string) {
  const cartStore = useCartStore()
  const selectedOption = getSelectedOption(optionName, inputName)
  if (selectedOption) {
    cartStore.updateOption(selectedOption, inputName)
  }
}

function getSelectedOption(optionName: string, inputName: string) {
  const cartStore = useCartStore()
  const selectedCard = cartStore.getConfigOptions?.find((item: ConfigurationI) => item.name === inputName)
  return selectedCard?.options.find((item: ConfigurationOptionI) => item.name === optionName)
}

async function loadProduct(
  slug: string | LocationQueryValue[],
  group: string | LocationQueryValue[],
  currency: string,
  optionName?: string,
  optionValue?: string,
) {
  const marketStore = useMarketStore()
  const cartStore = useCartStore()
  cartStore.emptyCart()
  await marketStore.loadProductsGroups()
  if (marketStore.productsGroups) {
    for (let i = 0; i < marketStore.productsGroups.length; i++) {
      if (marketStore.productsGroups[i].slug === group) {
        await marketStore.loadProducts(group)
        if (marketStore.products) {
          for (let j = 0; j < marketStore.products.length; j++) {
            if (marketStore.products[j].slug === slug) {
              marketStore.updateChosenProduct(marketStore.products[j])
              await cartStore.loadProductOptions(slug, currency)
              if (optionName && optionValue) {
                changeOptions(optionName, optionValue)
              }
            }
          }
        }
      }
    }
  }
}

async function loadTax(userCountry: string) {
  const cartStore = useCartStore()
  await cartStore.loadVat(userCountry)
}

async function customizeBeforeEnter(to: RouteLocationNormalized) {
  const hasRequiredQuery = to.query.currency && to.query.group && to.query.slug && to.query.country

  if (!hasRequiredQuery) return

  const { slug, group, currency, country, optionName, optionValue } = to.query

  await loadProduct(
    slug as string | LocationQueryValue[],
    group as string | LocationQueryValue[],
    String(currency),
    optionName ? String(optionName) : undefined,
    optionValue ? String(optionValue) : undefined,
  )
  await loadTax(String(country))
}

export default (router: Router) => {
  router.addRoute({
    path: '/cart',
    name: 'CartPage',
    component: () => import('@/modules/cart/views/CartPage.vue'),
    children: [
      {
        path: '/cart/customize',
        name: 'CustomizePage',
        component: () => import('@/modules/cart/views/CustomizePage.vue'),
        beforeEnter: customizeBeforeEnter,
        meta: {
          layout: 'DefaultLayout',
          allowGuest: true,
        },
      },
      {
        path: '/cart/checkout',
        name: 'CheckoutPage',
        component: () => import('@/modules/cart/views/CheckoutPage.vue'),
        meta: {
          layout: 'DefaultLayout',
          allowGuest: true,
        },
      },
    ],
    meta: {
      layout: 'DefaultLayout',
    },
  })

  router.addRoute({
    path: '/cart/complete_checkout',
    name: 'CompleteCheckoutPage',
    component: () => import('@/modules/cart/views/CompleteCheckoutPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
